import type { CourseCurriculumLocalizationSectionsItem } from './courseCurriculumLocalizationSectionsItem';

/**
 * 언어별 커리큘럼 구성 정보
 */
export interface CourseCurriculumLocalization {
  /** 언어 코드 (예: ko, en) */
  language: string;
  /** 해당 언어로 변환된 섹션 목록 */
  sections: CourseCurriculumLocalizationSectionsItem[];
}
